import {
  CatalogItem, GROUP_RELATIONS,
  GroupBucket,
  Relation,
  RelationsMap
} from "@shared/core";

export type Grouped<T extends { group: string }> = {
  type: string;
  relation: Relation;
  items: T[];
};

export function groupByRelation(
  items: CatalogItem[],
  rels: RelationsMap = GROUP_RELATIONS
): GroupBucket[] {
  const buckets: Record<string, CatalogItem[]> = {};
  for (const it of items) {
    const g = it.group && rels[it.group] ? it.group : '__unknown__';
    (buckets[g] ||= []).push(it);
  }
  return Object.keys(rels)
    .filter((gid) => buckets[gid]?.length)
    .map((gid) => ({ relation: rels[gid], items: buckets[gid] }));
}

